import Icon from './Icon.vue'
import Loader from './Loader.vue'

const components = {
    Icon,
    Loader,
}

const Utils = {

    install(Vue) {

        for (let name in components) {
            const component = components[name]

            if (component) {
                Vue.component(name, component)
            }
        }
    }
}
export default Utils
